import React from "react";

const MessageSvg = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7085 0.53125H5.29183C2.16683 0.53125 0.0834961 2.61458 0.0834961 5.73958V11.9896C0.0834961 15.1146 2.16683 17.1979 5.29183 17.1979H9.4585L14.0939 20.2812C14.7814 20.7396 15.7085 20.25 15.7085 19.4167V17.1979C18.8335 17.1979 20.9168 15.1146 20.9168 11.9896V5.73958C20.9168 2.61458 18.8335 0.53125 15.7085 0.53125ZM14.146 9.71875H6.85433C6.42725 9.71875 6.07308 9.36458 6.07308 8.9375C6.07308 8.51042 6.42725 8.15625 6.85433 8.15625H14.146C14.5731 8.15625 14.9272 8.51042 14.9272 8.9375C14.9272 9.36458 14.5731 9.71875 14.146 9.71875Z"
        fill="white"
      />
    </svg>
  );
};

export default MessageSvg;
